import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Logo from "../assets/img/skor-white-logo.svg";
import Flag from "../assets/img/flag.svg";
import Cancelimg from "../assets/img/cancel-01.svg";
import AuthContext from "../context/auth/AuthContext";
import { useContext, useRef, useState, useCallback, useEffect } from "react";
import { haveValue, toast, validatePhoneNumber } from "../helper/common";
import downIcon from "../assets/img/down-icon-dark.svg";
import useTranslator from "../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import copy from "copy-to-clipboard";
import { FaRegCopy } from "react-icons/fa6";
import { PhoneInput } from "react-international-phone";
import LandLordContext from "../context/landlord/LandLordContext";
import i18next from "i18next";
import ShareProfileModal from "../components/ShareProfileModal";
import TenantContext from "../context/tenant/TenantContext";
import ApplicationContext from "../context/application/ApplicationContext";
import axiosInstance from "../services/authWrapper";
import TopUpCreditModal from "../components/TopUpCreditModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../Utils/workspaceRoleCapabilities";

function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const Header = ({
  setIsSidebarCollapse,
  isSidebarCollapse,
  isSidebarClicked,
  setIsSidebarClicked,
  currentWorkspace = null,
}) => {
  const { workspaceId } = useParams();
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantContext = useContext(TenantContext);
  const {
    updateDownloadedCheck,
    fullProfileShared,
    removeSharedProfile,
    loadSharedProfiles,
    shareProfile,
    SetIsSecWelcomePopup,
  } = tenantContext;
  const {
    myApplications,
    shareApplicationWithLandlord,
    reloadApplications,
    landlordRequests,
    loadLandlordRequests,
  } = useContext(ApplicationContext);
  const [showModal, setShowModal] = useState(false);
  const [showInviteTenantModel, setShowInviteTenantModel] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerPhone, setSharePhone] = useState("");
  const [sharerName, setSharerName] = useState(null);
  const [sendingInvitation, setSendingInvitation] = useState(false);
  const _shareProfileParam =
    new URLSearchParams(window.location.search).get("shareprofilemodal") ===
    "true";
  const [isShareProfileModal, setIsShareProfileModal] =
    useState(_shareProfileParam);
  const [showShareProfileWelcomePopup, setShowShareProfileWelcomePopup] =
    useState(
      new URLSearchParams(window.location.search).get("welcome") === "true"
    );
  const [showRemove, setShowRemove] = useState(false);
  const [removeLandlordId, setRemoveLandlordId] = useState(null);
  const { sendInvitationToTenant } = useContext(LandLordContext);
  const [currentLandlordPage, setCurrentLandlordPage] = useState(1);
  const [landlordsOrig, setAllLandlordsOrig] = useState([]);
  const [totalLandlordPage, setTotalLandlordPage] = useState(0);
  const [loading1, setLoading1] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [landlords, setAllLandlords] = useState([]);
  const [showSharedModal, setShowSharedModal] = useState(false);
  const [tempLandlord, setTempLandlord] = useState("");
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const [unreadCount, setUnreadCount] = useState(0);
  const queryParam = new URLSearchParams(window.location.search);
  const shareWithEvent = queryParam.get("shareWith");
  const docuSignEvent = queryParam.get("event");
  const inviteTenantParam = queryParam.get("inviteTenant");
  const profile_type = queryParam.get("profile_type");
  const svgRef = useRef();
  const authContext = useContext(AuthContext);
  const { userType, user, logout, changeUserLng, notifications } = authContext;

  const isGuarantorUser = user?.gurantor_for?.length > 0;

  useEffect(() => {
    if (haveValue(user?.lang)) {
      handleLanguageChange(user?.lang);
    }
  }, [user?.lang]);

  useEffect(() => {
    if (_shareProfileParam) {
      const url = new URL(window.location.href);
      url.searchParams.delete("shareprofilemodal");
      window.history.replaceState({}, "", url.toString());
    }

    const handlePopState = () => {
      if (
        new URLSearchParams(window.location.search).get("shareprofilemodal") ===
        "true"
      ) {
        setIsShareProfileModal(true);
        const url = new URL(window.location.href);
        url.searchParams.delete("shareprofilemodal");
        window.history.replaceState({}, "", url.toString());
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const takeMeToProfile = () => {
    if (userType == "landlord") {
      navigate(`/${workspaceId}/${userType}-profile`);
    } else {
      navigate(`/${userType}-profile`);
    }
  };

  useEffect(() => {
    if (haveValue(inviteTenantParam) && inviteTenantParam) {
      setShowInviteTenantModel(true);
    }
  }, [inviteTenantParam]);

  useEffect(() => {
    var count = 0;
    if (notifications && notifications.length > 0) {
      notifications.forEach((val) => {
        if (val.marked_read == false) {
          count++;
        } else {
          return;
        }
      });
      setUnreadCount(count);
    }
  }, [notifications]);

  const handlecopyUrl = () => {
    copy(
      user?.role === "landlord" &&
        user?.current_workspace?.customLinkSlug &&
        user?.current_workspace?.customLinkEnabled === true
        ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
        : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
    );
    toast.success(_t("linkCopied"));
  };

  const handleCopyShareQrCode = () => {
    copy(
      `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/profile-request?sharedProfileLink=${user?._id}`
    );
    toast.success(_t("linkCopied"));
  };

  const handleDownloadShareQr = useCallback(async () => {
    const svg = svgRef.current.innerHTML;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    downloadBlob(blob, `myimage.svg`);
    await updateDownloadedCheck(user?._id);
  }, []);

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      setSendingInvitation(true);
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSendingInvitation(false);
        setSharerEmail(null);
        setShowEmailModal(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const sendInvitationViaPhone = async (e) => {
    e.preventDefault();
    const validate = validatePhoneNumber(sharerPhone);
    if (!validate.isValid) {
      toast.error(validate.message);
      return false;
    } else {
      try {
        const response = await sendInvitationToTenant({
          type: "phone",
          name: sharerName,
          phone: sharerPhone,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharePhone("");
        setShowPhoneModal(false);
      }
    }
  };
  const [processingLandlordId, setProcessingLandlordId] = useState(null);

  const shareProfileFun = (
    userid,
    landlordid,
    profiletype,
    landlord,
    confirm = false
  ) => {
    //set confirm to true if londord is macc
    if (landlordid == process.env.REACT_APP_MACC_LANDLORED_ID) {
      confirm = true;
    }
    if (confirm) {
      setProcessingLandlordId(landlordid);
      shareProfile(userid, landlordid, "null", profiletype, {
        shareType: "shareBtn",
      })
        .then((res) => {
          if (res) setShowSharedModal(true);
          setTempLandlord(landlord);
          // loadLandlords();
          // loadSharedProfiles(user?._id, "full");
        })
        .catch((err) => {
          setShowSharedModal(false);
        })
        .finally(() => {
          setProcessingLandlordId(false);
        });
    }
  };

  const loadLandlords = async () => {
    setLoading1(true);
    const tenantid = localStorage.getItem("saveduserid");
    await axiosInstance
      .get(
        `${
          process.env.REACT_APP_SERVER_URL
        }/landlords/alllandlords?page=${currentLandlordPage}&limit=${2}&searchText=${searchText}&tenantid=${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        const temp = res.data.landlords;
        setTotalLandlordPage(res?.data?.totalPages);
        setAllLandlords(res.data.landlords);
        setAllLandlordsOrig(res.data.landlords);
        setLoading1(false);

        if (haveValue(shareWithEvent) && haveValue(docuSignEvent)) {
          const foundLL = temp.filter((val) => val._id == shareWithEvent);
          var userId = localStorage.getItem("saveduserid");
          if (docuSignEvent === "signing_complete") {
            shareProfileFun(userId, foundLL[0]?._id, "full", foundLL[0], true);
          } else if (docuSignEvent === "share_start") {
            shareProfileFun(userId, foundLL[0]?._id, "full", foundLL[0]);
          }
        }
      })
      .catch((err) => {
        setLoading1(false);
        console.log(err);
      });
    return true;
  };

  const [removeLandlordLoading, setRemoveLandlordLoading] = useState(false);

  const handleRemoveLandlord = async () => {
    if (fullProfileShared !== null && haveValue(removeLandlordId)) {
      var sharedProfileId = null;
      for await (const profileShared of fullProfileShared) {
        if (profileShared.landlordid === removeLandlordId) {
          sharedProfileId = profileShared?._id;
          break;
        }
      }
      if (haveValue(sharedProfileId)) {
        setRemoveLandlordLoading(true);
        removeSharedProfile(sharedProfileId)
          .then((res) => {
            toast.success(_t("profileUnshared"));
            // loadLandlords();
            loadSharedProfiles(user?._id, "full");
            reloadApplications().catch(() => {});
            setShowRemove(false);
            setIsShareProfileModal(true);
          })
          .catch((err) => {
            console.log(err);
            setShowRemove(false);
          })
          .finally(() => {
            setRemoveLandlordLoading(false);
          });
      }
    }
  };

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  const [isCreditModal, setIsCreditModal] = useState(false);

  return (
    <>
      <nav
        class={`navbar navbar-expand-lg navbar-light ${
          userType === "landlord" ? "position-fixed top-0" : "position-static"
        }`}
      >
        <div
          class={`container container-fluid ${
            userType === "landlord"
              ? "navbar-landlord-container navbar-container"
              : "navbar-container"
          }`}
        >
          <div className="row" style={{ alignItems: "center", width: "100%" }}>
            {userType === "landlord" && (
              <div className="col sidebarIconWrapper">
                <div
                  className={`sidebarIcon ${
                    isSidebarCollapse ? "sidebarIconActive" : ""
                  }`}
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isSidebarClicked) {
                      setIsSidebarClicked(true);
                      setIsSidebarCollapse(true);
                    } else {
                      setIsSidebarClicked(false);
                      setIsSidebarCollapse(false);
                    }
                  }}
                  onMouseEnter={() => {
                    if (!isSidebarClicked) {
                      setIsSidebarCollapse(true);
                    }
                  }}
                >
                  <img src="/images/sidebarIcon.svg" alt="Sidebar Icon" />
                </div>
              </div>
            )}
            {userType === "landlord" ? (
              <div className="col-md-2 navbarLogoWrapper">
                <h4 className="WorkspaceNameText mb-0">
                  {currentWorkspace?.name}
                </h4>
              </div>
            ) : (
              <div className="col-md-1 navbarLogoWrapper">
                <Link to="/">
                  <img
                    src={Logo}
                    alt="Skor Logo"
                    style={{ height: "2.024vw" }}
                  />
                </Link>
              </div>
            )}
            <div className="col hideOnMobile p-0">
              {!location.pathname.includes("workspace-dashboard") ? (
                <div
                  class="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    {userType === "landlord" && (
                      <li class="nav-item d-flex align-items-center">
                        <div className="tutorial-tenant-tab">
                          {/* <div class="megadropdown megadropdown2">
                          <button class="megadropdown-toggle" type="button">
                            {_t("tenant")}
                            <img
                              class="icon small_icon"
                              src="/images/icon-down-grey.svg"
                              alt=""
                            />
                          </button> */}
                          {/* <div class="megadropdown-menu"> */}
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname.includes("/profile-request") ||
                              (location.pathname?.includes(
                                "/profile-property"
                              ) &&
                                profile_type !== "tenant_check")
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to={`/${workspaceId}/profile-request`}
                          >
                            {_t("tenantProfiles")}
                            {/* <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          /> */}
                          </Link>
                        </div>
                        <div>
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname?.includes("/created-tenant") ||
                              (location.pathname?.includes(
                                "/profile-property"
                              ) &&
                                profile_type === "tenant_check")
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to={`/${workspaceId}/created-tenant`}
                          >
                            {_t("tenantChecks")}
                            {/* <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          /> */}
                          </Link>
                          {/* </div> */}
                          {/* </div> */}
                        </div>
                        <div>
                          {/* <div class="megadropdown megadropdown2">
                          <button class="megadropdown-toggle" type="button">
                            {_t("properties")}
                            <img
                              class="icon small_icon"
                              src="/images/icon-down-grey.svg"
                              alt=""
                            />
                          </button>
                          <div class="megadropdown-menu"> */}
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname?.includes("/home")
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to={
                              user?.role === "landlord" &&
                              haveValue(workspaceId)
                                ? `/${workspaceId}/home`
                                : "/home"
                            }
                          >
                            {_t("myProperties")}
                            {/* <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          /> */}
                          </Link>
                        </div>
                        {user?.hasPaidRent && (
                          <div>
                            <Link
                              className={`d-flex align-items-center megadropdown-toggle ${
                                location.pathname?.includes(
                                  "/payment/property/list"
                                )
                                  ? "megadropdown-toggle-active"
                                  : ""
                              }`}
                              to={`/${workspaceId}/payment/property/list`}
                            >
                              {_t("propertiesPayments")}
                              {/* <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          /> */}
                            </Link>
                          </div>
                        )}
                      </li>
                    )}
                    {userType === "tenant" && (
                      <li class="nav-item d-flex align-items-center">
                        <div>
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname === "/home"
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to="/home"
                          >
                            {_t("skorReport")}
                          </Link>
                        </div>

                        <div>
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname === `/tenant/review/rental` ||
                              location.pathname === "/tenant/rentalStep"
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to={
                              user?.rent_paid
                                ? `/tenant/review/rental`
                                : "/tenant/rentalStep"
                            }
                          >
                            {_t("PropertyPayments")}
                          </Link>
                        </div>
                        {/* HERE: hide this for guarantor */}
                        {!isGuarantorUser && (
                          <div className="position-relative">
                            <Link
                              id="shareProfileLink"
                              className="d-flex align-items-center megadropdown-toggle"
                              onClick={() => setIsShareProfileModal(true)}
                            >
                              {_t("shareProfile")}
                              {(landlordRequests ?? []).length > 0 && (
                                <span className="share-profile-nav-badge">
                                  {(landlordRequests ?? []).length}
                                </span>
                              )}
                            </Link>
                            {showShareProfileWelcomePopup && (
                              <div className="welcome-popup share-profile-welcome-popup">
                                <div className="content-hover-div">
                                  <img
                                    src={Cancelimg}
                                    alt=""
                                    className="welcome-popup-close"
                                    onClick={() => {
                                      setShowShareProfileWelcomePopup(false);
                                      SetIsSecWelcomePopup(true);
                                    }}
                                  />
                                  <p className="text-break contentText">
                                    {_t("shareProfileSectionPopupMessage")}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        <div>
                          <Link
                            className={`d-flex align-items-center megadropdown-toggle ${
                              location.pathname === "/kelify"
                                ? "megadropdown-toggle-active"
                                : ""
                            }`}
                            to={"/kelify"}
                          >
                            {_t("kelify")}
                          </Link>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
            <div className="col-md-5 d-flex language-switch-wrapper">
              {/* {userType === "landlord" &&
                (haveValue(user?.agency_id)
                  ? user?.agency_id?.self_serving
                  : user?.self_serving) && (
                  <div className="creditsScoreWrapper">
                    <div className="creditsScoreIcon d-flex align-items-center justify-content-center">
                      <img src="/images/credit-point1.svg" />
                    </div>
                    <p>
                      {_t("creditPts")}:{" "}
                      <span>
                        {haveValue(user?.agency_id)
                          ? user?.agency_id?.credits
                          : user?.credits ?? 0}
                      </span>
                    </p>

                    {(haveValue(user?.agency_id)
                      ? user?.agency_id?.self_serving
                      : user?.self_serving) && (
                      <div
                        className="creditsScoreIcon creditsScorePlus d-flex align-items-center justify-content-center"
                        style={{ background: "#A3EB64" }}
                        onClick={() => setIsCreditModal(true)}
                      >
                        <img src="/images/addGreen.svg" />
                      </div>
                    )}
                  </div>
                )} */}
              {userType === "landlord" &&
              user?.current_workspace?.self_serving &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div className="creditsScoreWrapper">
                  <div className="creditsScoreIcon d-flex align-items-center justify-content-center">
                    <img src="/images/credit-point1.svg" />
                  </div>
                  <p>
                    {_t("creditPts")}:{" "}
                    <span>{user?.current_workspace?.credits ?? 0}</span>
                  </p>

                  {user?.current_workspace?.self_serving &&
                    WORKSPACE_ROLES_CAPABILITIES?.selfServing?.includes(
                      user?.current_workspace_role
                    ) && (
                      <div
                        className="creditsScoreIcon creditsScorePlus d-flex align-items-center justify-content-center"
                        style={{ background: "#A3EB64" }}
                        onClick={() => setIsCreditModal(true)}
                      >
                        <img src="/images/addGreen.svg" />
                      </div>
                    )}
                </div>
              ) : null}

              {/* {userType === "landlord" &&
              WORKSPACE_ROLES_CAPABILITIES?.tenants?.inviteTenant?.includes(
                user?.current_workspace_role,
              ) &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div className="shareQr hideOnMobile">
                  <a
                    className="btn btngreen invite_tenantbtn"
                    href={undefined}
                    onClick={(e) => setShowInviteTenantModel(true)}
                  >
                    <img
                      className="invite-tenant-icon"
                      src="/images/invite-tenant-icon.svg"
                      alt=""
                    />
                    {_t("requestProfile")}
                  </a>
                </div>
              ) : null} */}

              {currentLang == "es" ? (
                <div
                  className="language-switch-container language-switch-container-es hideOnMobile  cursor-pointer"
                  onClick={(e) => handleLanguageChange("en-us")}
                >
                  <p>ES</p>
                  <img
                    className="flag-image"
                    alt="Flag"
                    src="/images/spain-flag.png"
                  />
                </div>
              ) : (
                <div
                  className="language-switch-container hideOnMobile cursor-pointer"
                  onClick={(e) => handleLanguageChange("es")}
                >
                  <img className="flag-image" alt="Flag" src={Flag} />
                  <p>EN</p>
                </div>
              )}
              {/* {userType === "landlord" && ( */}
              {(userType === "tenant" ||
                WORKSPACE_ROLES_CAPABILITIES?.viewNotifications?.includes(
                  user?.current_workspace_role
                )) &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div
                  className="bell-icon-wrapper hideOnMobile"
                  onClick={() =>
                    navigate(
                      haveValue(workspaceId)
                        ? `/${workspaceId}/notification`
                        : "/notification"
                    )
                  }
                >
                  <img src="/images/bell-icon-black.svg" alt="Bell Icon" />
                  {unreadCount > 0 && (
                    <span className="badge text-white">{unreadCount}</span>
                  )}
                </div>
              ) : (
                ""
              )}
              {/* )} */}
              <div className="slideryt">
                <div className="re-div">
                  {userType !== "landlord" && (
                    <div className="dropdown admin-btn">
                      <Link data-bs-toggle="dropdown">
                        <div className="d-flex">
                          <div className="admin-name header-admin-name">
                            {userType == "landlord" ? (
                              haveValue(agencyDetails) &&
                              haveValue(agencyDetails?.company_name) &&
                              haveValue(agencyDetails?.company_logo) ? (
                                <img
                                  id="navbar_ll_image"
                                  src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${agencyDetails?.company_logo}`}
                                  alt=""
                                />
                              ) : (
                                <>
                                  {user?.fname_companyName &&
                                    user?.fname_companyName
                                      .charAt(0)
                                      .toUpperCase()}
                                  {user?.lname &&
                                    user?.lname.charAt(0).toUpperCase()}
                                </>
                              )
                            ) : (
                              <>
                                {user?.fname &&
                                  user?.fname.charAt(0).toUpperCase()}
                                {user?.lname &&
                                  user?.lname.charAt(0).toUpperCase()}
                              </>
                            )}
                          </div>
                          <img
                            src={downIcon}
                            alt="arrow-down"
                            className="ms-2"
                          />
                        </div>

                        <ul
                          className="dropdown-menu header-mobile-dropdown"
                          data-bs-auto-close="inside"
                        >
                          <div
                            className={`hover-dropdown-mobile hover-dropdown `}
                            style={{ display: "block" }}
                          >
                            {userType === "tenant" && (
                              <Link
                                onClick={() => navigate(`/user/edit?step=1`)}
                              >
                                <img src="/images/edit-icon-white.svg" alt="" />{" "}
                                {_t("editProfile")}
                              </Link>
                            )}
                            {userType === "landlord" && (
                              <Link onClick={takeMeToProfile} to={undefined}>
                                <img src="/images/eye-icon.svg" alt="" />{" "}
                                {_t("viewProfile")}
                              </Link>
                            )}
                            {userType === "landlord" && (
                              <>
                                <Link
                                  className="hideOnDesktop"
                                  onClick={() => setShowInviteTenantModel(true)}
                                >
                                  <img
                                    className="invite-tenant-icon"
                                    src="/images/invite-tenant-icon.svg"
                                    alt=""
                                  />
                                  {_t("requestProfile")}
                                </Link>
                                {/* {haveValue(user?.isParentLL) &&
                                user?.isParentLL && (
                                  <Link
                                    onClick={() =>
                                      navigate(`/${workspaceId}/sub/landlords`)
                                    }
                                  >
                                    <img
                                      className="invite-tenant-icon"
                                      src="/images/multiple-user.svg"
                                      alt=""
                                    />
                                    {_t("users")}
                                  </Link>
                                )} */}
                              </>
                            )}
                            <Link
                              className=""
                              onClick={(e) => setShowModal(true)}
                            >
                              <img src="/images/logout-icon.svg" alt="" />{" "}
                              {_t("logout")}
                            </Link>
                            <div
                              className="language-switch-mobile pb-0 hideOnDesktop"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {currentLang == "es" ? (
                                <div
                                  className="language-switch-container language-switch-container-es cursor-pointer"
                                  onClick={(e) => handleLanguageChange("en-us")}
                                >
                                  <p>ES</p>
                                  <img
                                    className="flag-image me-0"
                                    alt="Flag"
                                    src="/images/spain-flag.png"
                                  />
                                </div>
                              ) : (
                                <div
                                  className="language-switch-container cursor-pointer"
                                  onClick={(e) => handleLanguageChange("es")}
                                >
                                  <img
                                    className="flag-image me-0"
                                    alt="Flag"
                                    src={Flag}
                                  />
                                  <p>EN</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </ul>
                      </Link>
                    </div>
                  )}
                </div>
                <Modal
                  show={showModal}
                  centered
                  className="newmodalui wrapper-modal asguarantor"
                >
                  <Modal.Header></Modal.Header>
                  <Modal.Body>
                    <div className="forminput forminput-btngrp row100">
                      {_t("areYouSureYouWantToLogout")}
                    </div>
                    <div className="btngroup row100 gridbar">
                      <button
                        className="btn btnoutline cancel-btn"
                        type="button"
                        onClick={(e) => setShowModal(false)}
                      >
                        {_t("cancel")}
                      </button>
                      <button
                        className="btn btnorange"
                        type="button"
                        onClick={logout}
                      >
                        {_t("logout")}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>
                <Modal
                  show={showInviteTenantModel}
                  onHide={(e) => setShowInviteTenantModel(false)}
                  centered
                  className="newmodalui max-w-lg wrapper-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{_t("yourProfileQR")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex flex-column align-items-center justify-content-center text-grey-color">
                      <p>
                        {_t("shareThisLinkSoThatTenantProfileWillBeLinkedTo")}
                      </p>
                      <p className="d-flex align-items-center custom-gap-1">
                        <span
                          className="d-flex align-items-center custom-gap-1"
                          style={{ fontWeight: 600 }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className="inviteTenantHomeSvg"
                          >
                            <path
                              d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                              fill="#253837"
                            />
                          </svg>
                          {user?.current_workspace?.name}
                        </span>{" "}
                        {_t("workspaceAutomatically")}
                      </p>
                    </div>
                    <div className="qr-code-div qrcode-copy" ref={svgRef}>
                      <QRCode
                        id="qr_code_image"
                        value={
                          user?.role === "landlord" &&
                          user?.current_workspace?.customLinkSlug &&
                          user?.current_workspace?.customLinkEnabled === true
                            ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
                            : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
                        }
                      />
                    </div>

                    <div className="qr-link-copi share-and-copy-div">
                      <input
                        type="text"
                        disabled
                        value={
                          user?.role === "landlord" &&
                          user?.current_workspace?.customLinkSlug &&
                          user?.current_workspace?.customLinkEnabled === true
                            ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
                            : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
                        }
                      />
                      <button type="button" onClick={handlecopyUrl}>
                        <FaRegCopy />
                        {_t("copyURL")}
                      </button>
                    </div>
                    {user?.current_workspace?.customLinkEnabled && (
                      <div className="d-flex align-items-center justify-content-end custom-domain-link-wrapper">
                        {/* <div className="custom-domain-link">
                          <span className="dot" />
                          <span>{_t("usingCustomDomain")}: </span>
                          <span>{`${window.location.host}/oauth/`}</span>
                          <span>{user?.current_workspace?.customLinkSlug}</span>
                        </div> */}
                        <div
                          className="underline cursor-pointer editInvitationSettingLink"
                          onClick={() => {
                            setShowInviteTenantModel(false);

                            const params = new URLSearchParams(location.search);
                            params.set("openEditableTab", "invitations");

                            navigate({
                              pathname: location.pathname,
                              search: `?${params.toString()}`,
                            });
                          }}
                        >
                          {_t("editInvitationSettings")}
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-center gap-2 align-items-center inviteButtonWrapper mt-20px">
                      <button
                        type="button"
                        onClick={() => {
                          setShowEmailModal(true);
                          setShowInviteTenantModel(false);
                        }}
                        className="btn btngreen"
                      >
                        {_t(
                          "shareViaEmail",
                          "Landlord side in tenant profile section"
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setShowPhoneModal(true);
                          setShowInviteTenantModel(false);
                        }}
                        className="btn btngreen"
                      >
                        {_t(
                          "shareViaPhone",
                          "Landlord side in tenant profile section"
                        )}
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>
                <Modal
                  show={showEmailModal}
                  onHide={(e) => setShowEmailModal(false)}
                  centered
                  className="newmodalui max-w-lg wrapper-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{_t("email")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {/* <div className="qr-link-copi"> */}
                    <form
                      onSubmit={sendInvitationViaEmail}
                      className="d-flex flex-wrap mt-5 justify-content-center"
                    >
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="text"
                          onChange={(e) => {
                            setSharerName(e.target.value);
                          }}
                          className="form-control"
                          required={true}
                          placeholder={_t("name")}
                          onBeforeInput={(e) => {
                            const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(
                              e.data
                            );
                            if (!isValidChar) e.preventDefault();
                          }}
                        />
                      </div>
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="email"
                          onChange={(e) => {
                            setSharerEmail(e.target.value);
                          }}
                          className="form-control"
                          required={true}
                          placeholder={_t("email")}
                          onBeforeInput={(e) => {
                            if (!e.data) return; // allow delete, etc.

                            const value = e.data;

                            // Allow full pasted string
                            const isValid = /^[a-z0-9._%+-@]+$/.test(value);

                            if (!isValid) {
                              e.preventDefault();
                              return;
                            }

                            // Prevent multiple @ (handle paste too)
                            const existingValue = e.target.value;
                            const totalAtCount =
                              (existingValue + value).split("@").length - 1;

                            if (totalAtCount > 1) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 mt-3  d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btnNext btn"
                          disabled={sendingInvitation}
                          style={{ opacity: sendingInvitation ? 0.6 : 1 }}
                        >
                          {sendingInvitation
                            ? _t("sending")
                            : _t("sendInvitation")}
                        </button>
                      </div>
                    </form>
                    {/* </div> */}
                  </Modal.Body>
                </Modal>
                <Modal
                  show={showPhoneModal}
                  onHide={(e) => setShowPhoneModal(false)}
                  centered
                  className="newmodalui max-w-lg wrapper-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{_t("phone")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form
                      onSubmit={sendInvitationViaPhone}
                      className="d-flex flex-wrap mt-5 justify-content-center"
                    >
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="text"
                          onChange={(e) => {
                            setSharerName(e.target.value);
                          }}
                          className="form-control"
                          required={true}
                          placeholder={_t("name")}
                        />
                      </div>
                      <div className="form-group col-6 px-1 bodyContentset">
                        <PhoneInput
                          className="custom-input phone_input_info"
                          international
                          defaultCountry={"es"}
                          value={sharerPhone}
                          onChange={(e) =>
                            setSharePhone(e?.replace("+", "") || "")
                          }
                        />
                      </div>
                      <div className="col-12 mt-3 d-flex justify-content-center">
                        <button type="submit" className="btn btngreen">
                          {_t("sendInvitation")}
                        </button>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <div className="hideOnDesktop mobileNav">
          <ul className="d-flex justify-content-evenly align-items-center">
            {/* <li className="d-flex active flex-column align-items-center">
            <img src="/images/report-icon.svg" alt="" />
            {_t("skorReport")}
          </li> */}
            {userType === "tenant" && (
              <>
                <li
                  className={`d-flex active flex-column align-items-center ${
                    location.pathname === "/home" ? "mobileNav-active" : ""
                  }`}
                  onClick={() => navigate("/home")}
                >
                  <img src="/images/skor-report.svg" alt="" />
                  {_t("skorReport")}
                </li>
                <li
                  className="d-flex active flex-column align-items-center"
                  onClick={() => setIsShareProfileModal(true)}
                >
                  <img src="/images/user-share.svg" alt="" />
                  {_t("shareProfile")}
                  {(landlordRequests ?? []).length > 0 && (
                    <span className="share-profile-nav-badge">
                      {(landlordRequests ?? []).length}
                    </span>
                  )}
                </li>
              </>
            )}

            {userType === "landlord" && (
              <>
                <li
                  className={`d-flex flex-column align-items-center ${
                    location.pathname?.includes("/home")
                      ? "mobileNav-active"
                      : ""
                  }`}
                  onClick={() =>
                    navigate(
                      user?.role === "landlord" && haveValue(workspaceId)
                        ? `/${workspaceId}/home`
                        : "/home"
                    )
                  }
                >
                  <img src="/images/propertiesIcon.svg" alt="" />
                  {_t("myProperties")}
                </li>
                <li
                  className={`d-flex flex-column align-items-center tutorial-tenant-tab ${
                    location.pathname.includes("/profile-request")
                      ? "mobileNav-active"
                      : ""
                  }`}
                  onClick={() => navigate(`/${workspaceId}/profile-request`)}
                >
                  <img src="/images/user-icon.svg" alt="" />
                  {_t("tenantProfiles")}
                </li>
                <li
                  className={`d-flex flex-column align-items-center ${
                    location.pathname?.includes("/created-tenant")
                      ? "mobileNav-active"
                      : ""
                  }`}
                  onClick={() => navigate(`/${workspaceId}/created-tenant`)}
                >
                  <img src="/images/tenant-check.svg" alt="" />
                  {/* to="/created-tenant"
                        > */}
                  {_t("tenantChecks")}
                </li>
                {/* <li
                className="d-flex active flex-column align-items-center"
                onClick={() => navigate("/created-tenant")}
              >
                <img src="/images/checkIconNav.svg" alt="" />
                {_t("tenantChecks")}
              </li> */}
                {user?.hasPaidRent && (
                  <li
                    className={`d-flex flex-column align-items-center ${
                      location.pathname?.includes("/payment/property/list")
                        ? "mobileNav-active"
                        : ""
                    }`}
                    onClick={() =>
                      navigate(`/${workspaceId}/payment/property/list`)
                    }
                  >
                    <img src="/images/paymentIcon.svg" alt="" />
                    {_t("propertiesPayments")}
                  </li>
                )}
              </>
            )}

            <li
              className={`d-flex flex-column align-items-center ${
                location.pathname?.includes("/notification")
                  ? "mobileNav-active"
                  : ""
              }`}
              onClick={() =>
                navigate(
                  haveValue(workspaceId)
                    ? `/${workspaceId}/notification`
                    : "/notification"
                )
              }
            >
              <img src="/images/notification-icon.svg" alt="" />
              {_t("notifications")}
            </li>
          </ul>
        </div>
        {userType === "tenant" && (
          <ShareProfileModal
            isOpen={isShareProfileModal}
            onClose={() => setIsShareProfileModal(false)}
            loadLandlords={loadLandlords}
            setAllLandlords={setAllLandlords}
            setAllLandlordsOrig={setAllLandlordsOrig}
            landlordsOrig={landlordsOrig}
            searchText={searchText}
            setSearchText={setSearchText}
            loading1={loading1}
            landlords={landlords}
            setShowRemove={setShowRemove}
            shareProfileFun={shareProfileFun}
            setRemoveLandlordId={setRemoveLandlordId}
            processingLandlordId={processingLandlordId}
            myApplications={myApplications}
            shareApplicationWithLandlord={shareApplicationWithLandlord}
          />
        )}
        <Modal
          show={showRemove}
          onHide={() => {
            setShowRemove(false);
            setRemoveLandlordId(null);
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui wrapper-modal"
        >
          <Modal.Header>
            <Modal.Title className="modal-type">
              {_t("areYouSureYouWantToStopSharingYourSkorProfile")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="btngroup row100 gridbar d-flex justify-content-between gap-3">
              <button
                className="btn cancel-btn btnoutline modal-cancel-btn"
                type="button"
                onClick={(e) => {
                  setShowRemove(false);
                  setRemoveLandlordId(null);
                  setIsShareProfileModal(true);
                }}
              >
                {_t("cancel")}
              </button>
              <button
                className="btn btnorange modal-submit-btn"
                type="button"
                disabled={removeLandlordLoading}
                onClick={handleRemoveLandlord}
              >
                {_t("remove")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={showSharedModal}
          onHide={() => {
            setShowSharedModal(false);
            setTempLandlord("");
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui max-w-lg wrapper-modal newnaman"
        >
          <Modal.Body
            style={{ textAlign: "center" }}
            className="d-flex flex-column"
          >
            {_t("successYourSkorProfileHasBeenSuccessfullySharedWith")}{" "}
            {tempLandlord?.fname_companyName} {tempLandlord?.lname}.
            <button
              className="btn goBackBtn cursor-pointer"
              onClick={(e) => {
                setShowSharedModal(false);
                setTempLandlord("");
                setIsShareProfileModal(true);
              }}
            >
              {_t("goBack")}
            </button>
          </Modal.Body>
        </Modal>
      </nav>
      <TopUpCreditModal
        open={isCreditModal}
        setOpen={() => setIsCreditModal(false)}
      />
    </>
  );
};

export default Header;
